<template>
<div class="main-key-val">
  <div v-if="tagStyle">
    <p class="stat-value">{{ value }}</p>
    <el-tag size="mini" :type="tagStyle"  effect="dark">
      <p class="stat-legend">{{ legend }}</p>
    </el-tag>
  </div>
  <div v-else>
    <p class="stat-value">{{ value }}</p>
    <p class="stat-legend">{{ legend }}</p>
  </div>
</div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: 'n/c',
    },
    legend: {
      type: String,
      default: 'n/c',
    },
    tagStyle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      msg: 'Hi there!',
    };
  },
};
</script>

<style scoped>
  .stat-value {
    font-size: 14px;
    font-weight: bold;
    margin: 0px;
    text-align: left;
  }

  .stat-legend {
    font-size: 12px;
    margin: 0px;
    text-align: left;
  }

  .main-key-val {
    margin-bottom: 10px;
  }
</style>
